export function scrollToElement(element) {
    const column = element.closest('.e-kanban-content')
    if (!column) return

    element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
    })

    highlightElement(element)
}

function highlightElement(element, duration = 2000) {
    element.style.transition = 'all 0.3s ease'
    element.style.boxShadow = '0 0 0 3px #667eea'
    element.style.transform = 'scale(1.02)'

    setTimeout(() => {
        element.style.boxShadow = ''
        element.style.transform = ''
    }, duration)
}

export function findTicketCard(kanbanElement, ticketId) {
    const ticketCard = kanbanElement.querySelector(`.e-card[data-id="${ticketId}"]`)
    if (ticketCard) return ticketCard

    const allCards = kanbanElement.querySelectorAll('.e-card')
    for (const card of allCards) {
        if (card.textContent.includes(`#${ticketId}`) || card.textContent.includes(`${ticketId}`)) {
            return card
        }
    }
    return null
}